import { Env } from './env.js';
import { Pla } from './pla.js';// URLパラメータ

export class Opening {
    constructor() {
        this.body = {}
        this.html = {}
        this.env = {}
        this.paramAncher = {}
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        // 環境
        this.env = new Env();
        this.env.detectEnv();

        // URLパラメータ
        this.paramAncher = new Pla();
        this.paramAncher.getParam('op', location.href);

        if (document.getElementById('cover-opening')) {
            if (this.env.browser.ie11 || this.paramAncher.param == 0) {
                // Openingなし
                document.getElementById('cover-basic').classList.add('show');
                window.setTimeout(() => {//function() {
                    this.body.classList.add('opening-finished');
                }, 300);
            } else {
                this.flg = true;//this.startOpening();
            }
        }
    }


    startOpening() {
        if (document.getElementById('cover-opening')) {
            // Opening開始
            document.getElementById('cover-opening').classList.add('show');
            //console.log('Opening開始');

            window.setTimeout(() => {//function() {
                document.getElementById('cover-opening').classList.add('hide-scene-1');
            }, 500);
            window.setTimeout(() => {//function() {
                document.getElementById('cover-opening').classList.add('hide-scene-2');
                new Vivus('svg-animation', { type: 'scenario-sync', duration: 90, forceRender: false, animTimingFunction: Vivus.EASE })
            }, 1800);
            window.setTimeout(() => {//function() {
                document.getElementById('cover-opening').classList.add('hide-scene-3');

            }, 2200);

            let baseTime = 4400;
            //opening-finished追加
            window.setTimeout(() => {//function() {
                document.getElementById('cover-opening').classList.add('hide-scene-4');
            }, baseTime);
            window.setTimeout(() => {//function() {
                document.getElementById('cover-opening').classList.add('hide-scene-5');
            }, baseTime + 1200);

            //その後に opening-finished追加
            window.setTimeout(() => {//function() {
                this.body.classList.add('opening-finished');
                document.getElementById('cover-opening').classList.add('opening-finished');
            }, baseTime + 1600);
        }
    }

}